module.exports = __webpack_public_path__ + "static/media/iconProfessorActive.536a6a1c.svg";